import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../services/actions";
import AddToHome from "./AddToHome";
import AlertForLowQualityProduct from "./AlertForLowQualityProduct";
import AlertForVerifyEmail from "./AlertForVerifyEmail";
import AutoOrderConfirmation from "./AutoOrderConfirmation";
import CancelOrderConfirmation from "./CancelOrderConfirmation";
import DeleteUserConfirmation from "./DeleteUserConfirmation";
import DownloadNativeApplication from "./DownloadNativeApplication";
import EditEmail from "./EditEmail";
import EditUserProfile from "./EditUserProfile";
import NotEnoughBalanceAlert from "./NotEnoughBalanceAlert";
import OperationWhyModal from "./OperationWhy";
import OrderConfirmation from "./OrderConfirmation";
import RevokeConfirmation from "./RevokeConfirmation";

function ModalContainer() {
  const { visible, props } = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const onClose = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("modal");
    window.history.replaceState({}, document.title, url.toString());
    props?.revalidator?.revalidate?.();
    props?.onCloseEnd?.();

    dispatch(hideModal());
  };

  return (
    <div>
      {visible && <style>{"html,body {overflow-y:hidden}"}</style>}
      <NotEnoughBalanceAlert
        visible={visible === "notEnoughBalanceAlert"}
        onClose={onClose}
        {...props}
      />
      <AlertForLowQualityProduct
        visible={visible === "alertForLowQualityProduct"}
        onClose={onClose}
        {...props}
      />
      <OrderConfirmation
        visible={visible === "orderConfirmation"}
        onClose={onClose}
        {...props}
      />
      <AutoOrderConfirmation
        visible={visible === "autoOrderConfirmation"}
        onClose={onClose}
        {...props}
      />
      <CancelOrderConfirmation
        visible={visible === "cancelOrderConfirmation"}
        onClose={onClose}
        {...props}
      />
      <OperationWhyModal
        visible={visible === "operationWhy"}
        onClose={onClose}
        {...props}
      />
      <RevokeConfirmation
        visible={visible === "revokeConfirmation"}
        onClose={onClose}
        {...props}
      />
      <DeleteUserConfirmation
        visible={visible === "deleteUserConfirmation"}
        onClose={onClose}
        {...props}
      />
      <DownloadNativeApplication
        visible={visible === "downloadNativeApplication"}
        onClose={onClose}
        {...props}
      />
      <AddToHome
        visible={visible === "addToHome"}
        onClose={onClose}
        {...props}
      />
      <EditUserProfile
        visible={visible === "editUserProfile"}
        onClose={onClose}
        {...props}
      />
      <EditEmail
        visible={visible === "editEmail"}
        onClose={onClose}
        {...props}
      />
      <AlertForVerifyEmail
        visible={visible === "alertForVerifyEmail"}
        onClose={onClose}
        {...props}
      />
    </div>
  );
}

export default ModalContainer;
